import React, { useRef, useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import Pagination from 'react-js-pagination';
import { useLocation, useNavigate } from 'react-router-dom';
import PDFLoader from './PDFLoader';
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;
/* pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url,
).toString();
 */
export default function PDFViewer() {


    const location = useLocation();
    const message = location.state.message;

    const [numPages, setNumPages] = useState(null);
    const [pageNumber, setPageNumber] = useState(1)

    const navigate = useNavigate();


    const goBack = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (window.history.length > 1) {
            navigate(-1);
        } else {
            alert('No history available to go back.');
        }
    };



    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }
    const handlePageChange = (pageNumber) => {
        setPageNumber(pageNumber);
    }

    const goToPreviousPage = () => {
        if (pageNumber > 1) {
            setPageNumber(pageNumber - 1);
        }
    };

    const goToNextPage = () => {
        if (pageNumber < numPages) {
            setPageNumber(pageNumber + 1);
        }
    };


    const divRef = useRef(null);
    const [isFullscreen, setIsFullscreen] = useState(false);

    const toggleFullscreen = () => {
        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else {
            divRef.current.requestFullscreen();
        }
    };

    const onChange = () => {
        setIsFullscreen(!!document.fullscreenElement);
    };

    useEffect(() => {
        document.addEventListener('fullscreenchange', onChange);

        // Cleanup listener on component unmount
        return () => {
            document.removeEventListener('fullscreenchange', onChange);
        };
    }, []);

    if (!message) {
        return <div>No PDF file provided.</div>;
    }

    return (
        <>
            <section ref={divRef} className={`pdf-viewer ${isFullscreen ? 'fullscreen' : ''}`}>
                <div className='container'>
                    <div className='row'>
                        <div className='d-flex justify-content-between align-items-center d-none'>
                            <button className="btn-6 view-all-btnn mb-4 bck_btn" onClick={goBack} tabIndex={-1}><i className="fas fa-long-arrow-alt-left me-2"></i>Back </button>

                            <button className="btn-6 view-all-btnn mb-4 bck_btn" onClick={toggleFullscreen}>
                                {isFullscreen ? 'Exit Fullscreen' : 'Go Fullscreen'}
                            </button>
                        </div>
                        <div className='col-md-12 text-start position-relative'>
                             <button className="btn-6 view-all-btnn mb-4 bck_btn" onClick={goBack}  tabIndex={-1}><i className="fas fa-long-arrow-alt-left me-2"></i>Back </button> 
                            <Document file={message} onLoadSuccess={onDocumentLoadSuccess} loading={<PDFLoader />}>
                                <Page pageNumber={pageNumber} renderTextLayer={false} renderAnnotationLayer={false} />
                            </Document>

                            {numPages && (
                                <Pagination
                                    activePage={pageNumber}
                                    itemsCountPerPage={1}
                                    totalItemsCount={numPages}
                                    pageRangeDisplayed={3}
                                    onChange={handlePageChange}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                />
                            )}


                            <button className="carousel-control-prev" type="button" onClick={goToPreviousPage}
                                disabled={pageNumber === 1}>
                                <span className="btn-6 view-all-btnn view-all-btnn-cr" aria-hidden="true">
                                    <img src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/%3e%3c/svg%3e" alt="Arrow Icon" />
                                </span>
                                <span className="visually-hidden">Previous</span>
                            </button>
                            <button className="carousel-control-next" type="button" onClick={goToNextPage}
                                disabled={pageNumber === numPages}>
                                <span className="btn-6 view-all-btnn view-all-btnn-cr" aria-hidden="true">
                                    <img src="data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e" alt="Arrow Icon" />
                                </span>
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>

                </div>

            </section>
        </>

    )
}
